import React from 'react';
import { Section } from './ui/Section';
import { GoldButton } from './ui/GoldButton';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <Section className="pt-32 pb-20" data-id="element-88">
      <div className="space-y-12 text-center md:text-left" data-id="element-89">
        <h1 className="text-4xl md:text-5xl lg:text-6xl leading-tight text-[#f5f0e8]" data-id="element-90">
          Si tu cuerpo tiene sueño pero tu mente no,{' '}
          <span className="text-[#c9a04e]" data-id="element-91">esto es para ti.</span>
        </h1>

        <div className="space-y-6 text-lg md:text-xl text-[#f5f0e8]/90 leading-relaxed font-light" data-id="element-92">
          <p data-id="element-93">Te acuestas cansada.</p>
          <p data-id="element-94">Cansada de verdad.</p>
          <p data-id="element-95">Apagas la luz…</p>
          <p data-id="element-96">y justo ahí empieza el turno de noche de tu cabeza.</p>

          <div className="py-4 space-y-4 text-[#8a9bb0]" data-id="element-97">
            <p data-id="element-98">Te recuerda lo que no hiciste.</p>
            <p data-id="element-99">Lo que dijiste raro.</p>
            <p data-id="element-100">Lo que puede salir mal mañana.</p>
            <p data-id="element-101">Lo que "deberías" estar controlando.</p>
          </div>

          <p data-id="element-102">Y tú, agotada, intentas negociar.</p>
          <p className="italic text-[#8a9bb0]" data-id="element-103">"Si me duermo ya…"</p>
          <p className="italic text-[#8a9bb0]" data-id="element-104">
            "Si no me duermo en 10 minutos…"
          </p>
          <p className="italic text-[#8a9bb0]" data-id="element-105">"¿Y si mañana estoy fatal?"</p>

          <p data-id="element-106">Pero cuanto más intentas dormir, menos pasa.</p>
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.2,
        duration: 0.8
      }} className="py-8 text-center" data-id="element-107">
          <p className="text-2xl md:text-3xl font-serif text-[#c9a04e] border-y border-[#c9a04e]/30 py-6 inline-block" data-id="element-108">
            No te falta sueño. Te falta cierre.
          </p>
        </motion.div>

        <div className="relative group perspective-1000" data-id="element-109">
          <motion.img src="https://cdn.magicpatterns.com/uploads/qEprePVn5oeoDzyRQRpRPr/Apaga_la_cabeza_2.png" alt="Kit Apaga la Cabeza en una mesita de noche" className="w-full rounded-lg shadow-2xl shadow-black/50 opacity-90 hover:opacity-100 transition-opacity duration-700" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1
        }} data-id="element-110" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#1a2332] via-transparent to-transparent opacity-20 pointer-events-none" data-id="element-111"></div>
        </div>

        <div className="space-y-6 text-center" data-id="element-112">
          <p className="text-xl leading-relaxed" data-id="element-113">
            <strong className="text-[#c9a04e]" data-id="element-114">Apaga la Cabeza</strong> es un
            kit imprimible de 7 noches para convertir la hora de dormir en un
            protocolo simple:
          </p>
          <p className="text-lg font-medium tracking-wide" data-id="element-115">
            Descargar → bajar el cuerpo → cerrar el bucle.
          </p>
          <p className="text-[#8a9bb0] text-sm uppercase tracking-widest pt-2" data-id="element-116">
            Sin promesas mágicas. Sin teoría eterna. Sin depender de motivación.
          </p>

          <div className="pt-8" data-id="element-117">
            <GoldButton href="#oferta" data-id="element-118">
              Quiero el Kit Apaga la Cabeza
            </GoldButton>
          </div>
        </div>
      </div>
    </Section>;
}